import { createFilledIcon } from "../createIcon";

export const UserProfileFilledIcon = createFilledIcon(
  <>
    <path d="M15.818 7.01c0 2.04-1.71 3.865-3.818 3.865-2.109 0-3.818-1.825-3.818-3.865S9.892 3 12 3c2.109 0 3.818 1.97 3.818 4.01ZM21 16.778C21 19.11 18.273 21 12 21s-9-1.89-9-4.222c0-2.332 4.03-4.222 9-4.222s9 1.89 9 4.222Z" />
  </>,
  "UserProfileFilledIcon"
);
